import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20film%20theater%20atmosphere%20with%20warm%20golden%20lighting%2C%20elegant%20movie%20screen%20glow%2C%20soft%20bokeh%20lights%2C%20dark%20theater%20seats%2C%20dramatic%20cinematic%20composition%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20artistic%20film%20photography%2C%20atmospheric%20mood&width=1800&height=900&seq=hero-main-bg&orientation=landscape"
          alt="妈妈的朋友2 - 影迷资讯站"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
          <i className="ri-fire-line text-primary-300 text-sm"></i>
          <span className="text-xs font-medium text-primary-200 whitespace-nowrap">
            热门影视资讯平台
          </span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 max-w-3xl leading-tight mb-4">
          妈妈的朋友2
        </h1>
        <p className="text-sm md:text-base text-background-200/90 max-w-xl mb-8 leading-relaxed">
          最全面的剧情解析、演员阵容介绍、观看指南与影评点评，帮助影迷快速找到所需信息，畅享优质影视体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/plot-analysis"
            className="px-7 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line mr-2"></i>
            查看剧情解析
          </Link>
          <Link
            to="/category/reviews"
            className="px-7 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-medium rounded-full hover:bg-background-50/25 border border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-chat-quote-line mr-2"></i>
            阅读影评点评
          </Link>
        </div>
      </div>
    </section>
  );
}